import { Component, Input } from '@angular/core';
import { BaseCmsComponent } from '@kion/data-models';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'kion-cms-search-result-title',
  templateUrl: './search-result-title.component.html',
  styleUrls: ['./search-result-title.component.scss']
})
export class SearchResultTitleComponent {
  @Input() component: BaseCmsComponent;

  query$: Observable<string>;

  constructor(private route: ActivatedRoute) {
    this.query$ = this.route.queryParams.pipe(
      map(
        param => {
          if (param.query) {
            return param.query
          }
          return ''
        }
      )
    )
  }
}
